var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"barChart",style:({
    'width': _vm.options.config.width,
    'height': _vm.options.config.height
  })})
}
var staticRenderFns = []

export { render, staticRenderFns }